<footer class="footer-area">
    <div class="divider"></div>
    <div class="container">
        <div class="row">
            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-footer-widget">
                    <div class="logo">
                        <a routerLink="/"><img src="assets/img/logo.svg" alt="image" style="max-width: 160px;"></a>
                    </div>
                    <p>Experience innovation and excellence at Kaims IT Services, a pioneering force delivering tailored
                        cutting-edge technology solutions. Our skilled professionals provide top-notch services in
                        software development, web design, cloud solutions, and IT consulting, ensuring seamless
                        integration for your business success.</p>
                </div>
            </div>
            <div class="col-lg-2 col-md-6 col-sm-6">
                <div class="single-footer-widget">
                    <h3>Company</h3>
                    <ul class="services-list">
                        <li><a routerLink="/about">About Us</a></li>
                        <li><a routerLink="/services">Services</a></li>
                        <li><a routerLink="/contact">Contact Us</a></li>
                    </ul>
                </div>
            </div>
            <div class="col-lg-3 col-md-6 col-sm-6">
                <div class="single-footer-widget">
                    <h3>Services</h3>
                    <ul class="support-list">
                        <li><a routerLink="/website-development">Website Development</a></li>
                        <li><a routerLink="/mobile-development">Application Development</a></li>
                        <li><a routerLink="/erp-cms">ERP/CMS</a></li>
                        <li><a routerLink="/custom-software-development">Custom Software Development</a></li>
                        <li><a routerLink="/digital-marketing">Digital Marketing</a></li>
                        <li><a routerLink="/hosting-registration">Domain & Hosting Registration</a></li>
                    </ul>
                </div>
            </div>
            <div class="col-lg-3 col-md-6 col-sm-6">
                <div class="single-footer-widget">
                    <h3>Contact Info</h3>
                    <ul class="footer-contact-info">
                        <li>Location: <a href="https://maps.app.goo.gl/AT6788joRPRqy5pd9" target="_blank">
                                A-201, Aleeza Business Center, Ahmedabad - India</a>
                        </li>
                        <li>Email: <a href="mailto:info&#64;kaimsit.com">info&#64;kaimsit.com</a></li>
                        <li>Phone: <a href="tel:+919408877110">(+91) 940 8877 110</a></li>
                    </ul>
                    <!-- <ul class="social">
                        <li><a href="#" target="_blank"><i class="bx bxl-facebook"></i></a></li>
                        <li><a href="#" target="_blank"><i class="bx bxl-twitter"></i></a></li>
                        <li><a href="#" target="_blank"><i class="bx bxl-linkedin"></i></a></li>
                        <li><a href="#" target="_blank"><i class="bx bxl-instagram"></i></a></li>
                    </ul> -->
                </div>
            </div>
        </div>
        <div class="copyright-area">
            <p>Copyright © {{currentYear}} <a href="https://kaimsit.com/" target="_blank">Kaims IT Services</a>. All
                rights reserved.</p>
        </div>
    </div>
</footer>

<div class="go-top"><i class='bx bx-chevron-up'></i></div>